/// <amd-module name="Feed/Legacy/Actions/FeedSettings/NavigateToPermissionsHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { IFeedDataService } from "Feed/Legacy/DataServices/FeedsDataService";
import { filterWellKnownPermissions } from "Feed/Legacy/Helpers/PermissionHelper";
import { FeedPermission } from "Feed/Common/Contracts/Feed";

/**
 * When user navigates to feed settings permission
 *  1. set loading spinner
 *  2. get feed's permission from server
 *  3. filter out roles that aren't shown in UI
 *  4. set data is fetched from server
 */
export class NavigateToPermissionsHandler {
    public static async handleAsync(state: IFeedSettingsState, emit: () => void): Promise<void> {
        state.isLoadingPermissions = true;
        emit();

        const feedsDataService: IFeedDataService = state.pageContext.getService<IFeedDataService>("IFeedDataService");
        const includeIds: boolean = true;
        return feedsDataService.getFeedPermissionsAsync(state.feed(), includeIds, false, null, true).then(
            (permissions: FeedPermission[]) => {
                state.feedPermissions = filterWellKnownPermissions(permissions);
                state.isLoadingPermissions = false;
                state.isPermissionDataLoadedFromServer = true;
                emit();
            },
            (reason: Error) => {
                state.isLoadingPermissions = false;
                throw reason;
            }
        );
    }
}
